import { Routes } from '@angular/router';
import { AuthGuard } from './_guards/auth.guard';
import { CustomerMappingComponent } from './pages/customer-mapping/customer-mapping.component';
import { LoginComponent } from './pages/login/login.component';
import { StoreComponent } from './pages/store/store.component';
import { VisitComponent } from './pages/visit/visit.component';
import { WorkOrderComponent } from './pages/work-order/work-order.component';
import { ReportComponent } from './pages/report/report.component';
import { ReprocessingComponent } from './pages/reprocessing/reprocessing.component';
import { FaqComponent } from './components/faq/faq.component';
import { BlankPageComponent } from './pages/blank-page/blank-page.component';


export const routes: Routes = [
  {path: '', component: WorkOrderComponent, canActivate: [AuthGuard]},
  {path: 'visits', component: VisitComponent, canActivate: [AuthGuard]},
  {path: 'customer-mapping', component: CustomerMappingComponent, canActivate: [AuthGuard]},
  {path: 'stores', component: StoreComponent, canActivate: [AuthGuard]},
  {path: 'report', component: ReportComponent, canActivate: [AuthGuard]},
  {path: 'login', component: LoginComponent},
  {path: 'reprocessing', component: ReprocessingComponent, canActivate: [AuthGuard]},
  {path: 'faq', component: FaqComponent, canActivate: [AuthGuard]},
  {path: 'blank', component: BlankPageComponent},
  {path: '**', redirectTo: '', pathMatch: 'full'}
];
